import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { redirectToDomainLogin } from '~/services/redirects';
import Box from '~/ui/components/Box/Box';
import Button from '~/ui/components/Button/Button';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

function ErrorBoundary() {
  const intl = useIntl();

  return (
    <FlexLayout
      alignItems="center"
      flexDirection="column"
      p={6}
      sx={{ textAlign: 'center' }}
    >
      <Box>
        <Box mb={6}>
          <img
            src="/evisort.png"
            alt="Evisort"
            title="Evisort"
            style={{ width: '180px' }}
          />
        </Box>
        <Box py={6}>
          <Text variant="xl-dense-bold">
            <FormattedMessage
              id="ErrorBoundary.somethingWentWrong"
              defaultMessage="Sorry! Something went wrong."
              description="Error boundary main error message"
            />
          </Text>
        </Box>
        <Box py={4} sx={{ width: '470px' }}>
          <Text color="gray-800" variant="s-dense">
            <FormattedMessage
              id="ErrorBoundary.encounteredIssue"
              defaultMessage="Looks like we’ve encountered an issue. It has been reported to our team and we will get around to fixing it soon. Sorry for the inconvenience."
              description="Error boundary explanation message"
            />
          </Text>
        </Box>
        <FlexLayout
          alignItems="center"
          flexDirection="column"
          p={6}
          sx={{ textAlign: 'center' }}
        >
          <Button
            text={intl.formatMessage({
              id: 'ErrorBoundary.goToHome',
              defaultMessage: 'Go to Home',
              description: 'Button to go to home page from error boundary',
            })}
            variant="outlined"
            onClick={() => redirectToDomainLogin()}
          />
        </FlexLayout>
      </Box>
    </FlexLayout>
  );
}

export default ErrorBoundary;
